export const fioRegexp = /[А-Яа-яёЁ-]+\s[А-Яа-яёЁ-]+(\s[А-Яа-яёЁ-]+)?/;
export const fioWithMiddlenameRegexp = /[А-Яа-яёЁ-]+\s[А-Яа-яёЁ-]+(\s[А-Яа-яёЁ-]+)/;

export const telephoneRegexp = /^\+7 \([0-9]{3}\) [0-9]{3}-[0-9]{2}-[0-9]{2}$/;

export const driverLicenseRegexp = /^([\d]{2}(([\d]{2})|([а-яА-ЯёЁ]{2}))\s[\d]{6})$/;
